import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import { useTranslation } from "react-i18next";

import ConfigurationDashboard from "../components/ConfigurationDashboard";
import SeoTags from '@/components/shared/SeoTags';

/**
 * OrgaConfigurationPage - Page d'administration pour la configuration d'organisation
 * Permet de gérer les paramètres de l'organisation (logo, nom, description, couleurs)
 */
/**
 * Note: Cette page est protégée par ProtectedRoute dans routes.tsx
 * Les vérifications de permissions sont gérées au niveau du guard de route
 */
const OrgaConfigurationPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-secondary mt-1">
      <SeoTags 
        title={`${t('admin.configuration.breadcrumb.configuration')} | CashLive`}
        description={t('admin.configuration.breadcrumb.configuration')}
        url={typeof window !== 'undefined' ? window.location.href : ''}
        noIndex={true}
      />
      {/* Breadcrumb Navigation */}
    

      {/* Configuration Dashboard - No gap */}
      <ConfigurationDashboard />
    </div>
  );
};

export default OrgaConfigurationPage;
